export const ApiUrl = 'https://apis.drvakil.ir/graphql'
// export const ApiUrl = 'http://192.168.1.5:4000/graphql'
export const UploadsUrl = 'https://apis.drvakil.ir/uploads'
export const Url = 'https://apis.drvakil.ir'
// export const Redirect = 'http://localhost:3001'
export const Redirect = 'http://panel.drvakil.ir'
